<div class="alert-popup">
<div class="popup-container d-flex flex-column">
    <label class="heading-text">
      Location Required!!!
    </label>
  <label class="content">
   {{data.message}}
  </label>
  
  <label class="content">
    Go to your browser or device settings to enable location services.
  </label>
  <div class="btn" mat-dialog-actions>
    <button mat-button (click)="closeReachLocatonDialog()">OK</button>
  </div>
  </div>
</div>
